import * as Scrivito from "scrivito";

const EventWidget = Scrivito.provideWidgetClass("EventWidget", {
  attributes: {
    destination: ["reference", { only: ["EventPage"] }],
  },
});

export default EventWidget;
